var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83203 2.83203C11.3462 2.83203 12.6033 2.83203 13.3843 3.6619C14.1654 4.49176 14.1654 5.8274 14.1654 8.4987C14.1654 11.17 14.1654 12.5056 13.3843 13.3355C12.6033 14.1654 11.3462 14.1654 8.83203 14.1654H6.16536C3.6512 14.1654 2.39413 14.1654 1.61308 13.3355C0.832031 12.5056 0.832031 11.17 0.832031 8.4987C0.832031 5.8274 0.832031 4.49176 1.61308 3.6619C2.39413 2.83203 3.6512 2.83203 6.16536 2.83203H8.83203Z",
    stroke: "#858C94",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83203 10.8346C3.90446 9.40962 6.4013 9.33189 7.4987 10.8346M6.33136 7.33462C6.33136 7.97896 5.80904 8.50129 5.16471 8.50129C4.52038 8.50129 3.99804 7.97896 3.99804 7.33462C3.99804 6.6903 4.52038 6.16797 5.16471 6.16797C5.80904 6.16797 6.33136 6.6903 6.33136 7.33462Z",
    stroke: "#858C94",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.83203H12.1667",
    stroke: "#858C94",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5H10.8333",
    stroke: "#858C94",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCard);
export default __webpack_public_path__ + "static/media/student-card.ebc529536f26f8ef0e8029f3d03457c8.svg";
export { ForwardRef as ReactComponent };